import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from 'sonner';

const NewsletterCTA = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    toast.success('Successfully subscribed!', {
      description: 'You\'ll receive our latest updates and offers.'
    });
    
    setEmail('');
    setIsSubmitting(false);
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-foreground rounded-[32px] px-6 sm:px-10 md:px-16 py-10 md:py-14"
        >
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            {/* Left Content */}
            <div className="flex-1">
              <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl text-background leading-tight mb-4">
                Ready to Get<br />
                Our New Stuff?
              </h2>
              
              {/* Newsletter Form */}
              <form onSubmit={handleSubmit} className="flex items-center gap-2 max-w-md">
                <div className="relative flex-1">
                  <Input
                    type="email"
                    placeholder="Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="h-12 pl-4 pr-4 rounded-full bg-background/10 border-background/20 text-background placeholder:text-background/50 focus:bg-background/20"
                    required
                  />
                </div>
                <motion.div whileTap={{ scale: 0.95 }}>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="h-12 px-6 rounded-full bg-background text-foreground hover:bg-background/90 transition-colors"
                  >
                    {isSubmitting ? (
                      <span className="animate-pulse">...</span>
                    ) : (
                      'Send'
                    )}
                  </Button>
                </motion.div>
              </form>
            </div>

            {/* Right Content */}
            <div className="lg:max-w-sm">
              <h3 className="font-semibold text-background/90 mb-2">
                Notice: Be the next e-Marek
              </h3>
              <p className="text-background/60 text-sm leading-relaxed">
                Don't waste for your needs. Check the near opposite, cool alert, 
                center, polykanarquale SIG searching any simpukardesh, isyn tip get.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterCTA;
